var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
/**
 * ## Importing
 *
 * ```
 * import { ListItem } from "@naturacosmeticos/natds-web";
 * ```
 */
exports.ListItem = ListItem_1.default;
exports.default = exports.ListItem;
//# sourceMappingURL=ListItem.js.map